import Vue from 'vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import i18n from './lang/lang'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css' // Vuesax styles
import 'material-icons/iconfont/material-icons.css'
// import HorizontalList from 'vue-horizontal-list'
import LongdoMap from 'longdo-map-vue'

import App from './App.vue'

Vue.config.productionTip = false
Vue.use(LongdoMap, {
  load: {
    apiKey: '9c56c0f4e9e7d5747eaf4af6ec66c4bd'
  }
})
Vue.use(Vuesax)
// Vue.use(HorizontalList)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
